import { Tag, Tooltip } from "antd";
import moment from "moment";
import React from "react";
import { dayPermissionLabel } from "../../services/studentDayPermission.service";

/** Small "DP" badge for a session excused by an approved Day Permission. */
const DayPermissionTag = ({ info }) => {
  if (!info) return null;
  const time =
    info.from_time || info.to_time
      ? ` (${info.from_time ? moment(info.from_time).format("hh:mm A") : "-"}${
          info.to_time ? ` - ${moment(info.to_time).format("hh:mm A")}` : ""
        })`
      : "";
  return (
    <Tooltip
      title={`${dayPermissionLabel(info.permission_for)}${time}${
        info.reason ? ` - ${info.reason}` : ""
      }`}
    >
      <Tag color="blue" style={{ margin: 0 }}>
        DP
      </Tag>
    </Tooltip>
  );
};

export default DayPermissionTag;
